var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n  El folio de requisición debe ser agregado por tu consultor. Por favor ponte en contacto con él para continuar con el proceso.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }